// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qh","play":"rh"};